/* istanbul ignore file */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import IconClose from 'yoda-core-components/lib/assets/svg/closeIconNew.svg';
import Loading from 'yoda-site-components/lib/components/Loading/Loading';
import LoadingAction from 'yoda-site-components/lib/actions/LoadingAction';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { selectDeviceType } from 'yoda-site-components/lib//selectors/ContextSelector';
import InnerImageZoom from '../InlineZoomViewer/InnerImageZoom';
import * as styles from './ImageZoom.css';

const cx = classNames.bind(styles);

class VerticalZoomCarousel extends Component {
    static defaultProps = {
        dataAutomationId: '',
        productImages: [],
        actions: {},
        closeCallback: null,
        selectedIndex: 0,
        isNative: false,
        deviceType: {},
    };

    static propTypes = {
        dataAutomationId: PropTypes.string,
        productImages: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        closeCallback: PropTypes.func,
        selectedIndex: PropTypes.number,
        isNative: PropTypes.bool,
        deviceType: PropTypes.oneOfType([PropTypes.object]),
    };

    constructor() {
        super();
        this.state = {
            modelOpen: true,
            updateWidth: false,
            selectedIndexScrollComplete: false,
        };
        this.closeModal = this.closeModal.bind(this);
        this.scrollRef = React.createRef();
    }

    componentDidMount() {
        const imageNodeList = this.scrollRef.current.querySelectorAll('img');
        Promise.all(
            Array.from(imageNodeList)
                .filter((img) => !img.complete)
                .map(
                    (img) =>
                        new Promise((resolve) => {
                            // eslint-disable-next-line no-param-reassign, no-multi-assign
                            img.onload = img.onerror = resolve;
                        })
                )
        ).then(() => {
            const scrollElement = this.props.productImages[this.props.selectedIndex].url.split(
                '?'
            )[0];
            if (scrollElement && !this.state.selectedIndexScrollComplete) {
                const scrollToElem =
                    this.scrollRef &&
                    this.scrollRef.current &&
                    this.scrollRef.current.querySelectorAll(`[src*="${scrollElement}"]`);

                if (scrollToElem) {
                    scrollToElem[0].scrollIntoView();
                    this.setState({ selectedIndexScrollComplete: true });
                }
            }
        });
    }

    closeModal() {
        this.setState({
            modelOpen: false,
            selectedIndexScrollComplete: false,
        });

        this.props.closeCallback && this.props.closeCallback();
    }

    updateWidth = (data) => {
        this.setState({ updateWidth: data });
    };

    render() {
        const { innerHeight } = window;
        const { innerWidth } = window;
        const isLandscapeOrientation = innerWidth > innerHeight;
        const imageWidth = isLandscapeOrientation ? innerWidth : innerHeight;
        const smallImageWidth = isLandscapeOrientation ? innerWidth : innerHeight + 500;
        return (
            <ModalBox
                showModal={this.state.modelOpen}
                onClose={this.closeModal}
                defaultCloseBtn={false}
                modalTheme={cx('VerticalImageModel')}
                modalBlockTheme={cx('VerticalImageModelBlock')}
                automationId={`${this.props.dataAutomationId}-ModelBox`}
                modalContentTheme={dt(['sm:!mt-0', 'sm:!max-h-[100vh]', 'overflow-y-hidden'])}
            >
                <div className={`${cx('holder')} ${dt(['sm:!relative'])}`}>
                    <button
                        className={`${cx('closeButtonNew', {
                            verticalCarouselClose: this.props.isNative,
                        })} ${dt([
                            'absolute',
                            'top-2',
                            'right-2',
                            'p-1',
                            'z-[1]',
                            'bg-white',
                            'bg-opacity-75',
                        ])}`}
                        onClick={this.closeModal}
                        data-automation-id="modal-button"
                    >
                        <Icon
                            type="button"
                            iconType="svg"
                            width="40px"
                            height="40px"
                            viewBox="0 0 40 40"
                        >
                            <IconClose />
                        </Icon>
                    </button>
                    <div className={dt(['overflow-y-auto', 'h-screen'])}>
                        <div ref={this.scrollRef} className={cx('ZoomFigure')}>
                            {this.props.productImages.map((data) => (
                                <InnerImageZoom
                                    src={
                                        this.state.updateWidth
                                            ? this.props.deviceType.isMobile === true
                                                ? data.url.replace(/350/g, smallImageWidth)
                                                : data.url.replace(/550/g, smallImageWidth)
                                            : data.url
                                    }
                                    deviceType={this.props.deviceType}
                                    key={data.url}
                                    zoomSrc={
                                        this.props.deviceType.isMobile === true
                                            ? data.url.replace(/350/g, imageWidth)
                                            : data.url.replace(/550/g, imageWidth)
                                    }
                                    isLandscape={isLandscapeOrientation}
                                    updateWidth={this.updateWidth}
                                    shouldLoadZoomImgOnLoad
                                />
                            ))}
                        </div>
                    </div>
                </div>
                <Loading />
            </ModalBox>
        );
    }
}
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(LoadingAction, dispatch),
});
const mapStateToProps = (store) => ({
    deviceType: selectDeviceType(store),
});

export default connect(mapStateToProps, mapDispatchToProps)(VerticalZoomCarousel);
